module.exports = __webpack_public_path__ + "static/media/blockscan.d258c227.svg";